window.Cookie = require('js-cookie');
window.Velocity = require('velocity-animate');

require('waypoints/lib/noframework.waypoints.min.js');

/*=============================
=          Initialize         =
=============================*/

window.body = document.body;
window.hero = document.getElementById('hero');
window.main = document.querySelector('main');
window.footer = document.getElementById('footer');
window.header = document.getElementById('header');
window.headerHeight = header ? header.offsetHeight : 0;
window.topbar = document.getElementById('topbar');
window.topbarHeight = topbar ? topbar.offsetHeight : 0;
window.isSpanish = document.documentElement.lang == 'es';

!function(){if(!window.klaviyo){window._klOnsite=window._klOnsite||[];try{window.klaviyo=new Proxy({},{get:function(n,i){return"push"===i?function(){var n;(n=window._klOnsite).push.apply(n,arguments)}:function(){for(var n=arguments.length,o=new Array(n),w=0;w<n;w++)o[w]=arguments[w];var t="function"==typeof o[o.length-1]?o.pop():void 0,e=new Promise((function(n){window._klOnsite.push([i].concat(o,[function(i){t&&t(i),n(i)}]))}));return e}}})}catch(n){window.klaviyo=window.klaviyo||[],window.klaviyo.push=function(){var n;(n=window._klOnsite).push.apply(n,arguments)}}}}();

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.Promise = require('promise-polyfill').default;

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

var token = document.head.querySelector('meta[name="csrf-token"]');

if(token)
	window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
else
	console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');

/*=============================
=      Check Window Width     =
=============================*/

window.checkWidth = function checkWidth(width) {
	return window.innerWidth < width;
};

/*=============================
=       Lazyload Scripts      =
=============================*/

window.scriptWaypoint = function scriptWaypoint(el, src, offset) {
	var scriptWaypoint = new Waypoint({
		element: el,
		handler: function(direction) {
			addJS(src);

			this.destroy();
		},
		offset: offset
	});
};

window.addJS = function addJS(src) {
	var script = document.createElement('script');

	script.src = src;
	script.type = 'text/javascript';
	script.setAttribute('async', 'true');
	script.setAttribute('defer', 'true');

	document.body.appendChild(script);
};

/*=============================
=       Scroll To Element     =
=============================*/

window.scrollToElement = function scrollToElement(scrollTo) {
	Velocity(scrollTo, 'scroll', {duration: 800, offset: -(checkWidth(768) ? document.getElementById('nav-wrap').offsetHeight : headerHeight)});
};

/*=============================
=       Get URL Parameter     =
=============================*/

window.getParameter = function getParameter(obj, parameter) {
	var value = '';

	obj.href.split('&').forEach(function(param) {
		if(param.indexOf(parameter) > -1)
			value = param.split(parameter+'=')[1];
	});

	return value;
};

/*=============================
=       Google Map Styles     =
=============================*/

window.mapStyles = [
	{
		"featureType": "all",
		"elementType": "labels.text",
		"stylers": [
			{
				"visibility": "on"
			},
			{
				"color": "#454545"
			}
		]
	},
	{
		"featureType": "all",
		"elementType": "labels.text.stroke",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "administrative",
		"elementType": "labels.text",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "administrative.country",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "on"
			}
		]
	},
	{
		"featureType": "administrative.country",
		"elementType": "geometry.fill",
		"stylers": [
			{
				"visibility": "on"
			}
		]
	},
	{
		"featureType": "administrative.country",
		"elementType": "labels.text",
		"stylers": [
			{
				"visibility": "on"
			},
			{
				"weight": "0.01"
			}
		]
	},
	{
		"featureType": "administrative.locality",
		"elementType": "geometry.stroke",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "administrative.locality",
		"elementType": "labels.text",
		"stylers": [
			{
				"weight": "0.01"
			},
			{
				"visibility": "on"
			}
		]
	},
	{
		"featureType": "administrative.locality",
		"elementType": "labels.text.stroke",
		"stylers": [
			{
				"weight": "0.01"
			}
		]
	},
	{
		"featureType": "administrative.neighborhood",
		"elementType": "labels.text",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "administrative.neighborhood",
		"elementType": "labels.text.stroke",
		"stylers": [
			{
				"weight": "0.01"
			}
		]
	},
	{
		"featureType": "administrative.land_parcel",
		"elementType": "labels.text",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "landscape.man_made",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "landscape.natural",
		"elementType": "all",
		"stylers": [
			{
				"color": "#c4ecff"
			}
		]
	},
	{
		"featureType": "poi",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "poi.government",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "poi.school",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "poi.sports_complex",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "road",
		"elementType": "geometry.fill",
		"stylers": [
			{
				"color": "#ffffff"
			}
		]
	},
	{
		"featureType": "road",
		"elementType": "geometry.stroke",
		"stylers": [
			{
				"color": "#ffffff"
			}
		]
	},
	{
		"featureType": "road.highway",
		"elementType": "geometry.fill",
		"stylers": [
			{
				"color": "#f6fbfe"
			}
		]
	},
	{
		"featureType": "road.highway",
		"elementType": "geometry.stroke",
		"stylers": [
			{
				"weight": "0.50"
			},
			{
				"color": "#ffffff"
			}
		]
	},
	{
		"featureType": "road.highway",
		"elementType": "labels.text",
		"stylers": [
			{
				"weight": "0.01"
			}
		]
	},
	{
		"featureType": "road.highway",
		"elementType": "labels.text.stroke",
		"stylers": [
			{
				"weight": "0.01"
			}
		]
	},
	{
		"featureType": "road.highway",
		"elementType": "labels.icon",
		"stylers": [
			{
				"visibility": "on"
			},
			{
				"weight": "0.01"
			}
		]
	},
	{
		"featureType": "road.highway.controlled_access",
		"elementType": "labels.text",
		"stylers": [
			{
				"visibility": "on"
			}
		]
	},
	{
		"featureType": "road.local",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "on"
			}
		]
	},
	{
		"featureType": "road.local",
		"elementType": "geometry.fill",
		"stylers": [
			{
				"color": "#ffffff"
			}
		]
	},
	{
		"featureType": "road.local",
		"elementType": "geometry.stroke",
		"stylers": [
			{
				"color": "#ffffff"
			}
		]
	},
	{
		"featureType": "road.local",
		"elementType": "labels.text",
		"stylers": [
			{
				"color": "#7e7e7e"
			},
			{
				"weight": "0.01"
			},
			{
				"gamma": "1.07"
			}
		]
	},
	{
		"featureType": "road.local",
		"elementType": "labels.icon",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "transit",
		"elementType": "all",
		"stylers": [
			{
				"weight": "0.01"
			},
			{
				"color": "#8ed5f8"
			}
		]
	},
	{
		"featureType": "transit",
		"elementType": "labels.text.fill",
		"stylers": [
			{
				"gamma": "2.49"
			},
			{
				"color": "#8f8f8f"
			}
		]
	},
	{
		"featureType": "transit",
		"elementType": "labels.text.stroke",
		"stylers": [
			{
				"gamma": "0.59"
			}
		]
	},
	{
		"featureType": "transit.line",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "on"
			},
			{
				"weight": "5.07"
			}
		]
	},
	{
		"featureType": "transit.line",
		"elementType": "labels.icon",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "transit.station.airport",
		"elementType": "labels.icon",
		"stylers": [
			{
				"visibility": "on"
			}
		]
	},
	{
		"featureType": "transit.station.bus",
		"elementType": "labels.icon",
		"stylers": [
			{
				"visibility": "on"
			}
		]
	},
	{
		"featureType": "transit.station.rail",
		"elementType": "labels.icon",
		"stylers": [
			{
				"visibility": "on"
			}
		]
	},
	{
		"featureType": "water",
		"elementType": "all",
		"stylers": [
			{
				"color": "#dff5ff"
			}
		]
	}
];

/*========================================
=       Handle Klaviyo Form Triggers     =
=========================================*/

/* 
== NOTES FOR DEV REVIEW ==

After a lot of testing on these forms, I realized the form triggers we were 
originally using weren't following the guidelines the client had set up on klaviyo 
on their end. The two things that were still occurring when initializing the form 
triggers were:

- Forms were triggering right away as opposed to 30% page scroll.
- Forms had no 3 day cooldown period once closed.

On top of this, desktop forms would still trigger on mobile displays, even with the proper checks in place.
I eventually learned that klaviyo was using a key called "klaviyoOnsite" in localStorage to determine which forms were triggered when.
So instead of just using the form triggers, I also had to end up using the "klaviyoOnsite" key to stop certain forms from displaying.
*/

/* This function handles triggering the mobile forms at 30% page scroll */ 

let scrollTriggered = false;

function handleScrollForForm(formID) {
	return function() {
		const documentHeight = document.documentElement.scrollHeight;
		const scrollPosition = window.scrollY + window.innerHeight;
		const scrollPercentage = (scrollPosition / documentHeight) * 100;

		if (scrollPercentage >= 30 && !scrollTriggered) {
			scrollTriggered = true;
			window._klOnsite.push(['openForm', formID]);
			window.removeEventListener('scroll', handleScrollForForm(formID));
		}
	};
}

/* These variables contain the form IDs. These can be swapped out if client ever changes these forms. */

var engDeskFormID = 'Y3dpN5';
var spanDeskFormID = 'USzkZK';
var engMobFormID = 'RLvHg5';
var spanMobFormID = 'TaqHPK';

/*============================================================================================

If the user is new, we create the 'klaviyoOnsite' key stored in localStorage.
This is the same key klaviyo uses to track which forms should be disabled. Since no forms
are disabled for new users, both english and spanish forms would trigger for new users which 
was causing the original bug. We'll initialize the form ourself to make sure only the correct
forms are triggered.

============================================================================================*/

if (localStorage.getItem('klaviyoOnsite') === null) {
	localStorage.setItem('klaviyoOnsite', JSON.stringify({
		viewedForms:{modal:{disabledForms:{},viewedForms:{},disabledTeasers:{}}}
	}));
}

/*===========================================================================================================

We initialize some variables here to easily manipulate the 'klaviyoOnsite' key.

klObj = It simply contains the key's value and parse's it into an object.

disabledForms = the disabledForms object is what is used by klaviyo to determine which forms to not trigger.

viewedForms = the viewedForms object lists the forms that the user has seen, but has not closed. This will be
useful for removing forms from the disabledForms object if they haven't been seen by the user yet.

currentTime = Capture the current time in Unix timestamp which is what klaviyoOnsite uses to track time.

threeDays = 3 Days in seconds that will be used to determine if 3 days had passed since the form was closed.

============================================================================================================*/

var klObj = JSON.parse(localStorage.getItem('klaviyoOnsite'));
var disabledForms = klObj.viewedForms.modal.disabledForms;
var viewedForms = klObj.viewedForms.modal.viewedForms;
const currentTime = Math.floor(Date.now() / 1000);
const threeDays = 259200;

/*=============================================

The conditional logic below will check if:
- The current page is english or spanish
- The current page is in mobile or desktop view

===============================================*/

if (window.isSpanish) {
	if (body.classList.contains('mobile')) {

		/* If user is on mobile and the desktop forms have yet to be disabled, disable them now to prevent them from triggering on mobile.
		This will also account for a user who revisits the page 3 days later to prevent the forms from triggering again. */
		if (!disabledForms[engDeskFormID] || currentTime >= disabledForms[engDeskFormID].lastCloseTime + threeDays) disabledForms[engDeskFormID] = {lastCloseTime: currentTime};
		if (!disabledForms[spanDeskFormID] || currentTime >= disabledForms[spanDeskFormID].lastCloseTime + threeDays) disabledForms[spanDeskFormID] = {lastCloseTime: currentTime};

		//If the english mobile form has not been disabled yet, disable it now to prevent it from triggering on the spanish mobile page.
		if (!disabledForms.engMobFormID) disabledForms[engMobFormID] = {lastCloseTime: currentTime};

		/*To account for the chance that a user would visit the english page first, which would disable the spanish form before the user visits the spanish page,
		we check if the form is disabled without first being viewed. If this is the case, we remove the spanish form from the disabled forms object.*/
		if ((!viewedForms[spanMobFormID]) && (disabledForms[spanMobFormID])) delete disabledForms[spanMobFormID];

		/*The client's 30% scroll function is working, but the form trigger we have seems to ignore it completely.
		Therefore, we first check if the spanish form is disabled or, if it is, if 3 days have past since it's been disabled. 
		If we clear these checks, we add an event listener that calls a function that uses the form trigger if the user 
		scrolls 30% or more through the page.*/
		if (!disabledForms[spanMobFormID] || disabledForms[spanMobFormID].lastCloseTime + threeDays <= currentTime) {
			const scrollHandler = handleScrollForForm(spanMobFormID);
			window.addEventListener('scroll', scrollHandler);
		}

		/* The same logic persists with the other 3 checks for their respective language and display. The only difference
		is that we don't need the scroll function to trigger for the desktop forms. The 30% scroll bug seems to only affect the mobile
		forms, so I left that event listener out of the desktop checks. */
		
	} else if (!body.classList.contains('mobile')) {
		if (!disabledForms[engMobFormID] || currentTime >= disabledForms[engMobFormID].lastCloseTime + threeDays) disabledForms[engMobFormID] = {lastCloseTime: currentTime};
		if (!disabledForms[spanMobFormID] || currentTime >= disabledForms[spanMobFormID].lastCloseTime + threeDays) disabledForms[spanMobFormID] = {lastCloseTime: currentTime};
		if (!disabledForms.engDeskFormID) disabledForms[engDeskFormID] = {lastCloseTime: currentTime};
		if ((!viewedForms[spanDeskFormID]) && (disabledForms[spanDeskFormID])) delete disabledForms[spanDeskFormID];
	}
} else {
	if (body.classList.contains('mobile')) {
		if (!disabledForms[engDeskFormID] || currentTime >= disabledForms[engDeskFormID].lastCloseTime + threeDays) disabledForms[engDeskFormID] = {lastCloseTime: currentTime};
		if (!disabledForms[spanDeskFormID] || currentTime >= disabledForms[spanDeskFormID].lastCloseTime + threeDays) disabledForms[spanDeskFormID] = {lastCloseTime: currentTime};
		if (!disabledForms.spanMobFormID) disabledForms[spanMobFormID] = {lastCloseTime: currentTime};
		if ((!viewedForms[engMobFormID]) && (disabledForms[engMobFormID])) delete disabledForms[engMobFormID];
		if (!disabledForms[engMobFormID] || disabledForms[engMobFormID].lastCloseTime + threeDays <= currentTime) {
			const scrollHandler = handleScrollForForm(engMobFormID);
			window.addEventListener('scroll', scrollHandler);
		}
	} else if (!body.classList.contains('mobile')) {
		if (!disabledForms[engMobFormID] || currentTime >= disabledForms[engMobFormID].lastCloseTime + threeDays) disabledForms[engMobFormID] = {lastCloseTime: currentTime};
		if (!disabledForms[spanMobFormID] || currentTime >= disabledForms[spanMobFormID].lastCloseTime + threeDays) disabledForms[spanMobFormID] = {lastCloseTime: currentTime};
		if (!disabledForms.spanDeskFormID) disabledForms[spanDeskFormID] = {lastCloseTime: currentTime};
		if ((!viewedForms[engDeskFormID]) && (disabledForms[engDeskFormID])) delete disabledForms[engDeskFormID];
	}
}

/* After the check is complete, we set the klaviyoOnsite key back into local storage. */ 

localStorage.setItem('klaviyoOnsite', JSON.stringify(klObj));

/*=============================
=            Segment          =
=============================*/

window.getTrackingParameters = function getTrackingParameters() {
	// Get Facebook/Meta Cookies
	var fbp = '';
	var fbc = '';

	if(Cookie.get('_fbp')) {
		fbp = Cookie.get('_fbp');
	}

	if(Cookie.get('_fbc')) {
		fbc = Cookie.get('_fbc');
	}

	// Get UTM values from Custom Cookie
	const utmCookie = Cookie.get('utm_params');
	var utms = utmCookie ? JSON.parse(utmCookie) : {};

	var utm_source = utms.utm_source && utms.utm_source !== null ? utms.utm_source : '';
	var utm_medium = utms.utm_medium && utms.utm_medium !== null ? utms.utm_medium : '';
	var utm_campaign = utms.utm_campaign && utms.utm_campaign !== null ? utms.utm_campaign : '';
	var utm_content = utms.utm_content && utms.utm_content !== null ? utms.utm_content : '';
	var utm_term = utms.utm_term && utms.utm_term !== null ? utms.utm_term : '';
	var ga_client_id = Cookie.get('_ga') ? Cookie.get('_ga').slice(6) : '';
	var fbclid = utms.fbclid && utms.fbclid !== null ? utms.fbclid : '';
	var sccid = utms.sccid && utms.sccid !== null ? utms.sccid : '';
	var ttclid = utms.ttclid && utms.ttclid !== null ? utms.ttclid : '';
	var ob_click_id = utms.ob_click_id && utms.ob_click_id !== null ? utms.ob_click_id : '';
	var tb_click_id = utms.tb_click_id && utms.tb_click_id !== null ? utms.tb_click_id : '';
	var msclkid = utms.msclkid && utms.msclkid !== null ? utms.msclkid : '';
	var gclid = utms.gclid && utms.gclid !== null ? utms.gclid : '';
	var gbraid = utms.gbraid && utms.gbraid !== null ? utms.gbraid : '';
	var wbraid = utms.wbraid && utms.wbraid !== null ? utms.wbraid : '';

	return {
		full_url: window.location.href,
		landing_full_url: Cookie.get('landing_full_url'),
		utm_source,
		utm_medium,
		utm_campaign,
		utm_content,
		utm_term,
		ga_client_id,
		fbclid,
		sccid,
		ttclid,
		ob_click_id,
		tb_click_id,
		msclkid,
		gclid,
		gbraid,
		wbraid,
		fbp,
		fbc
	};
};

window.segmentTracking = function segmentTracking(eventName, params) {
	// Tracking parameters
	const tracking = getTrackingParameters();

	// Segment AnonymousId
	const anonymousId = Cookie.get('segment_anonymousId');

	// Merge all parameters
	const trackParams = {...params, ...tracking};

	// Identify
	analytics.identify(null, params, function() {
		// Track
		analytics.track(eventName, trackParams, {
			anonymousId
		});
	});
};